import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

const BreadCrumb = ({ title }) => {
    return (
        <React.Fragment>
            <div className="d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0">{title}</h4>

                {/* <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item"><Link to="#">{pageTitle}</Link></li>
                        <li className="breadcrumb-item active">{title}</li>
                    </ol>
                </div> */}

            </div>
        </React.Fragment>
    );
};

export default BreadCrumb;